import { ChevronLeft } from 'lucide-react';
import { LongArrow } from '@/components/brand/long-arrow';
import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

const NAV_BUTTON =
  'group relative z-[5] inline-flex h-[38px] items-center gap-2.5 rounded-full px-3.5 text-[13px] font-semibold text-white/[.86] transition-colors hover:bg-white/[.08] hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#6FA0FF] max-md:min-h-touch max-md:min-w-touch max-md:justify-center';

/**
 * Voltar / "n de N" / Próxima ("Começar" on the cover) under the slide
 * (NEWS-01/04). Below 768px the buttons keep only their icons.
 */
export function PlayerNav({
  index,
  total,
  onPrev,
  onNext,
}: {
  index: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}) {
  const { LL } = useI18nContext();
  const isFirst = index === 0;
  const isLast = index === total - 1;

  return (
    <div className="relative z-[4] grid grid-cols-[1fr_auto_1fr] items-center px-[22px] pb-[18px] max-md:px-3 max-md:pb-[max(14px,env(safe-area-inset-bottom))] [@media(min-width:768px)_and_(max-height:800px)]:pb-3">
      <button
        type="button"
        onClick={onPrev}
        disabled={isFirst}
        className={cn(
          NAV_BUTTON,
          'justify-self-start disabled:pointer-events-none disabled:opacity-0'
        )}
      >
        <ChevronLeft aria-hidden="true" className="size-4" strokeWidth={1.6} />
        <span className="max-md:sr-only">{LL.whatsNew.player.previous()}</span>
      </button>
      <span className="text-xs tabular-nums text-white/[.64]">
        {LL.whatsNew.player.counter({ current: index + 1, total })}
      </span>
      <button
        type="button"
        onClick={onNext}
        // The outro has no next slide (NEWS-03); `invisible` keeps the grid.
        className={cn(NAV_BUTTON, 'justify-self-end', isLast && 'invisible')}
      >
        <span className="max-md:sr-only">
          {isFirst ? LL.whatsNew.player.start() : LL.whatsNew.player.next()}
        </span>
        <LongArrow lineClassName="w-7 group-hover:w-10" />
      </button>
    </div>
  );
}
